export interface IAuthToken {
    token: string;
    expires: Date;
    referenceToken: string;
}